import React, { useState } from "react";
import axios from "axios";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { FaRegCheckCircle } from 'react-icons/fa';

import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";

import Popup from "./Popup";
import "./Contact.css";

const theme = createTheme();

export default function Contact() {
  const [isOpen, setIsOpen] = useState(false);
  const [Name, setName] = useState('');
  const [Email, setEmail] = useState('');
  const [Subject, setSubject] = useState('');
  const [Message, setMessage] = useState('');

  // create a new contact object with the form data
  const newContact = {
    Name,
    Email,
    Subject,
    Message
  };


  const togglePopup = async () => {
    try {
      if (onSubmit) {
        onSubmit();
        setIsOpen(!isOpen);
        // eslint-disable-next-line no-native-reassign
        window.setTimeout(() => { setIsOpen(false) }, 3000)
      }
    }
    catch (err) {
      console.log(err)
    }
  }

  const onSubmit = async () => {
    try {
      const url = 'https://api.aizonixsolutions.com/api/create_contact/';
      const response = await axios.post(url, newContact);
      console.log(response.data);
      setName('');
      setEmail('');
      setSubject('');
      setMessage('');
    }
    catch (err) {
      console.log(err);
    }
  }

  const validationSchema = Yup.object().shape({
    Name: Yup.string()
      .required('Name is required'),
    Email: Yup.string()
      .required('Email is required')
      .email('Email is invalid'),
    Subject: Yup.string()
      .required('Subject is required'),
    Message: Yup.string()
      .required('Message is required'),
  });

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema)
  });

  const preventDefault = async (e) => {
    e.preventDefault();
  }

  return (
    <ThemeProvider theme={theme}>
      <Container
        component="main"
        maxWidth="xl"
        style={{ backgroundColor: "#fafafa", padding: "25px" }}
        id="Contact"
      >
        <Box
          sx={{
            marginTop: 8,

            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography component="h1" variant="h5">
            <p
              style={{
                color: "#1E978C",
                fontWeight: "bolder",
                marginTop: "30px",
                fontSize: "0.67em",
              }}
            >
              HAVE ANY QUERY?
            </p>
            <p style={{ color: "black", fontWeight: "bolder", fontSize: "1.17em" }}>Contact Us</p>
            <p style={{ color: "black", fontSize: "14px", marginTop: "15px" }}>
              Do you have any questions, requests, ideas or maybe you simply want
              to chat with us to get to know us better.
              <br /> Whatever the reason, we’re here when you need to contact us.
            </p>
          </Typography>
          <Box component="form" noValidate sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="Name"
                  name="Name"
                  required
                  fullWidth
                  id="Name"
                  label="Name"
                  autoFocus
                  value={Name}
                  {...register('Name')}
                  error={errors.Name ? true : false}
                  onChange={(e) => setName(e.target.value)}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.Name?.message}
                </Typography>

              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  id="Email"
                  label="Email"
                  name="Email"
                  autoComplete="email"
                  value={Email}
                  {...register('Email')}
                  error={errors.Email ? true : false}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.Email?.message}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="Subject"
                  label="Subject"
                  name="Subject"
                  autoComplete="text"
                  value={Subject}
                  {...register('Subject')}
                  error={errors.Subject ? true : false}
                  onChange={(e) => setSubject(e.target.value)}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.Subject?.message}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="Message"
                  label="Message"
                  id="Message"
                  value={Message}
                  {...register('Message')}
                  error={errors.Message ? true : false}
                  onChange={(e) => setMessage(e.target.value)}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.Message?.message}
                </Typography>
              </Grid>
              <Grid item xs={12}></Grid>
            </Grid>
            <button onClick={handleSubmit(preventDefault && togglePopup)} type="submit" className="send">
              <div className="svg-wrapper-1">
                <div className="svg-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path fill="currentColor" d="M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z"></path>
                  </svg>
                </div>
              </div>
              <span>Send</span>
            </button>
            {isOpen && <Popup
              content={
                <div className="loggedIn-div">
                  <FaRegCheckCircle
                    className="icon"
                    size="18px"
                    color="azure"
                  />
                  <p className="loggedIn-p">Request Sent Successfully</p>
                </div>}
              handleClose={togglePopup}
            />}
            <Grid container justifyContent="flex-end">
              <Grid item></Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}